import React, { PureComponent } from 'react';
import './style.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isFunction } from 'lodash';

class GigCardShell extends PureComponent {
    constructor(props) {
        super(props);

        this.setTooltipPositionClass = this.setTooltipPositionClass.bind(this);
    }

    setTooltipPositionClass() {
        const { getGigCardContainerRef } = this.props,
            gigCardContainerRef = getGigCardContainerRef && getGigCardContainerRef(),
            gigCardContainerDimensions = gigCardContainerRef ? gigCardContainerRef.getBoundingClientRect() : null,
            gigCardDimensions = this.gigCardRef.getBoundingClientRect(),
            gigsContainerOffsetLeft = gigCardContainerDimensions ? gigCardContainerDimensions.left : 0,
            gigsContainerOffsetRight = gigCardContainerDimensions ? gigCardContainerDimensions.right : document.body.clientWidth,
            gigsContainerOffsetBottom = gigCardContainerDimensions ? gigCardContainerDimensions.bottom : document.body.clientHeight,
            tooltipIsOutOfContainerFromLeft = gigCardDimensions.left - gigCardDimensions.width - gigsContainerOffsetLeft < 0,
            tooltipIsOutOfContainerFromRight = gigsContainerOffsetRight - gigCardDimensions.right - gigCardDimensions.width < 0,
            tooltipIsOutOfContainerFromBottom = gigsContainerOffsetBottom - gigCardDimensions.bottom - (gigCardDimensions.height / 2) < 0;

        let tooltipPositionClass = '';

        if (!tooltipIsOutOfContainerFromLeft && tooltipIsOutOfContainerFromRight) {
            tooltipPositionClass = tooltipIsOutOfContainerFromBottom ? 'hint--top-right' : 'hint--bottom-right';
        } else {
            tooltipPositionClass = tooltipIsOutOfContainerFromBottom ? 'hint--top' : 'hint--bottom';
        }

        isFunction(this.props.setTooltipPositionClass) && this.props.setTooltipPositionClass(tooltipPositionClass);
    }

    render() {
        const { type, gigId, wrapperCls, children, isProExperience, isLimitedEdition } = this.props,
            classes = classNames(wrapperCls, 'gig-card-base', 'slide', type, 'js-gig-card', 'js-slide', { 'pro-experience': isProExperience, 'limited-edition-card': isLimitedEdition });

        return (
            <div ref={(ref) => this.gigCardRef = ref}
                data-gig-id={gigId}
                data-impression-identifier={gigId}
                className={classes}
                onMouseEnter={this.setTooltipPositionClass}>
                {children}
            </div>
        );
    }
}

GigCardShell.propTypes = {
    wrapperCls: PropTypes.string,
    gigId: PropTypes.number,
    type: PropTypes.string,
    children: PropTypes.any,
    isProExperience: PropTypes.bool,
    getGigCardContainerRef: PropTypes.func,
    setTooltipPositionClass: PropTypes.func
};

export default GigCardShell;



// WEBPACK FOOTER //
// ./src/shared/card_shell/index.js